













import { Component, Prop, Vue } from 'vue-property-decorator';

import VueCountryCode from 'vue-country-code-select';
import { Constants } from '@/common/Constants';
import { User } from '@/api';

interface Country {
	name: string;
	iso2: string;
}

@Component({
	components: {
		VueCountryCode,
	},
})
export default class UserCountrySelect extends Vue {
	@Prop({ required: true, type: Function })
	private onCountrySelected!: (countryCode: string) => void;

	@Prop({ required: true, type: Object })
	private user!: User;

	public get defaultCountry(): string {
		return this.user.preferences?.country ?? 'nz';
	}

	public selectedCountry: Country | null = null;

	public get allowedCountries(): string[] {
		return Constants.SUPPORTED_COUNTRY_CODES.map((countryCode: string) =>
			countryCode.toUpperCase(),
		);
	}

	public onSelect(country: Country): void {
		this.selectedCountry = country;
		this.onCountrySelected(country.iso2.toLowerCase());
	}
}
